import ConexionRechazadaComponent from '@/components/shared/ConexionRechazadaComponent'
import QRGeneradorComponent from '@/components/utils/QRGeneradorComponent.vue'

export default [{
    path: '/error-de-conexion',
    name: 'error-de-conexion',
    component: ConexionRechazadaComponent,
    meta: {
        requiresAuth: false
    },
    path: '/generador-qr/',
    name: 'qr-generador',
    component: QRGeneradorComponent,
    meta: {
        requiresAuth: false
    }
}, ]